import React, { Component } from 'react';
import PopUp from '../../../../commonModules/interface/PopUp';
import { TableLayout } from '../containers/Layout';
import { TableBody, TableRow, TableCell } from '@material-ui/core';
import ConfirmFormTemplate from '../transfers/Forms/ConfirmFormTemplate';

class ConfirmReappro extends Component {
    state = {  }
    render() {
        const { reappro } = this.props;
        const fieldList = [
            {name: "shop", label:"Shop", display:reappro.shopDisplay.label},
            {name: "shop_dest", label:"Shop Destinataire", display:reappro.shop_destDisplay.label},
            {name: "nature", label:"Nature", display:reappro.natureDisplay.label},
            {name: "transport", label:"Coût Transport", display:reappro.transport},
            {name:"taxes", label:"Autres Taxes", display:reappro.taxes},        
            {name:"products"},   
            {name: "totalArt"},   
            {name:"comments", label:"Commentaires",display:reappro.comments},
            {name:"discount", label:"Réduction Totale", display:reappro.discount},
        ]
        
        return (
            <PopUp 
                title="Confirmation Reappro" 
                close={this.props.handleClose}
                submitAction={ this.props.handleSubmit }
                disabledSubmit={this.props.sending}
                maxWidth="md" 
            >
                <TableLayout>
                    <TableBody>
                        <ConfirmFormTemplate
                            fieldList={fieldList}
                            transfer={reappro}
                        />                 
                    {/* {fieldList.map( field => {
                        if(reappro[field.name]){
                            if (field.name === "products"){
                                return reappro.products.map( prod => (
                                    <TableRow>
                                        <TableCell>{prod.display.label}</TableCell>
                                        <TableCell>{prod.quantity}</TableCell>
                                        <TableCell></TableCell>
                                    </TableRow>
                                ))
                                        
                            } else {
                                return (
                                    <TableRow>
                                        <TableCell>{field.label}</TableCell>
                                        <TableCell colSpan={3}>{field.display}</TableCell>
                                    </TableRow>
                                )
                            }
                        } 
                    })

                    }       */}
                                          
                    </TableBody>
                </TableLayout>
            </PopUp>
        );
    }
}

export default ConfirmReappro;